// This file is auto-generated by Kubb. Do not edit manually.
/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const agingIntoMedicareSchema = z.object({
  entryPointType: z.enum(["AGING_INTO_MEDICARE"]),
  memberId: z.string(),
  state: z.string(),
  turning65Date: z.string().date().describe("The date the member turns 65."),
  type: z.enum(["VANCE_AGING_INTO_MEDICARE"]),
  workspaceId: z.string(),
});
